import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';
import CookieDeclaration from '../../components/CookieDeclaration.vue';
// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'CookieDeclaration',
  props: {
  block: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props



const marginTop = computed(() => props.block.fields.MarginTop || 0);
const marginBottom = computed(() => props.block.fields.MarginBottom || 0);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "cookie-declaration",
    style: _normalizeStyle({ marginTop: _unref(marginTop), marginBottom: _unref(marginBottom) })
  }, [
    _createVNode(CookieDeclaration, {
      class: "cookie-declaration__content",
      "cookiebot-serial": __props.block.fields.CookiebotSerial
    }, null, 8, ["cookiebot-serial"])
  ], 4))
}
}

})